"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muteIconTemplate = exports.decreaseVolumeIconTemplate = exports.increaseVolumeIconTemplate = exports.rewindIconTemplate = exports.forwardIconTemplate = exports.playIconTemplate = exports.pauseIconTemplate = exports.containerTemplate = void 0;
var tslib_1 = require("tslib");
var container_dot_1 = tslib_1.__importDefault(require("./container.dot"));
var playIcon_dot_1 = tslib_1.__importDefault(require("./playIcon.dot"));
var pauseIcon_dot_1 = tslib_1.__importDefault(require("./pauseIcon.dot"));
var forwardIcon_dot_1 = tslib_1.__importDefault(require("./forwardIcon.dot"));
var rewindIcon_dot_1 = tslib_1.__importDefault(require("./rewindIcon.dot"));
var increaseVolumeIcon_dot_1 = tslib_1.__importDefault(require("./increaseVolumeIcon.dot"));
var decreaseVolumeIcon_dot_1 = tslib_1.__importDefault(require("./decreaseVolumeIcon.dot"));
var muteIcon_dot_1 = tslib_1.__importDefault(require("./muteIcon.dot"));
var containerTemplate = container_dot_1.default.default ? container_dot_1.default.default : container_dot_1.default;
exports.containerTemplate = containerTemplate;
var playIconTemplate = playIcon_dot_1.default.default ? playIcon_dot_1.default.default : playIcon_dot_1.default;
exports.playIconTemplate = playIconTemplate;
var pauseIconTemplate = pauseIcon_dot_1.default.default ? pauseIcon_dot_1.default.default : pauseIcon_dot_1.default;
exports.pauseIconTemplate = pauseIconTemplate;
var forwardIconTemplate = forwardIcon_dot_1.default.default ? forwardIcon_dot_1.default.default : forwardIcon_dot_1.default;
exports.forwardIconTemplate = forwardIconTemplate;
var rewindIconTemplate = rewindIcon_dot_1.default.default ? rewindIcon_dot_1.default.default : rewindIcon_dot_1.default;
exports.rewindIconTemplate = rewindIconTemplate;
var increaseVolumeIconTemplate = increaseVolumeIcon_dot_1.default.default
    ? increaseVolumeIcon_dot_1.default.default
    : increaseVolumeIcon_dot_1.default;
exports.increaseVolumeIconTemplate = increaseVolumeIconTemplate;
var decreaseVolumeIconTemplate = decreaseVolumeIcon_dot_1.default.default
    ? decreaseVolumeIcon_dot_1.default.default
    : decreaseVolumeIcon_dot_1.default;
exports.decreaseVolumeIconTemplate = decreaseVolumeIconTemplate;
var muteIconTemplate = muteIcon_dot_1.default.default ? muteIcon_dot_1.default.default : muteIcon_dot_1.default;
exports.muteIconTemplate = muteIconTemplate;
//# sourceMappingURL=index.js.map